var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map",
    clipPath: "url(#clip0_8039_50760)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3 4.39995L7.70002 2.19995L1.65002 4.39995V19.8L7.70002 17.6L14.3 19.8L20.35 17.6V2.19995L14.3 4.39995ZM8.52502 4.21295L13.475 5.86295V17.787L8.52502 16.137V4.21295ZM3.30002 5.55495L6.87502 4.25695V16.148L3.30002 17.446V5.55495ZM18.7 16.445L15.125 17.743V5.85195L18.7 4.55395V16.445Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8039_50760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBtnIcon);
export default __webpack_public_path__ + "static/media/map-btn-icon.d1dfed3c4a696ba0e3cfb5e41ed89805.svg";
export { ForwardRef as ReactComponent };